// extracted by mini-css-extract-plugin
export default {"loaderContainer":"ComponentLoader_loaderContainer__tOYGU","loader":"ComponentLoader_loader__VrxTl"};